import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    const modal = new bootstrap.Modal(this.modalTarget)
    modal.show()
  }
}